export default "__VITE_ASSET__D1RUNfn0__"